module.exports = __webpack_public_path__ + "static/default-blog-6da2f2fc7e962b9cc68707f775facec0.jpg";